import { render, staticRenderFns } from "./ComboSelectBehaviorEditor.vue?vue&type=template&id=f3fae8e2&scoped=true&"
import script from "./ComboSelectBehaviorEditor.vue?vue&type=script&lang=ts&"
export * from "./ComboSelectBehaviorEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ComboSelectBehaviorEditor.vue?vue&type=style&index=0&id=f3fae8e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3fae8e2",
  null
  
)

export default component.exports